import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams,Events } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { environment } from '../../environments/environment';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../../services/util';

@IonicPage()
@Component({
  selector: 'page-resident-id-card',
  templateUrl: 'resident-id-card.html',
})
export class ResidentIdCardPage {
  userData: any = {};
  loginDetail = {};
  residentType:string;
  societyLogo:any;
  imgUrl :any;
  errorLogo :any;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private loginProvider: LoginProvider,
    private toast: ToastProvider,
    public events: Events,
    private util : UtilService) {
      this.errorLogo = '/assets/images/logo/ism.png';
      this.imgUrl = "assets/images/logo/Final_Logo_grey"+(environment.icon?environment.icon:'')+".png";
      this.getProfile();
  }
  getProfile(){
  	this.loginProvider.profileDetails().then(profile => {
  		if(profile){
        this.userData = profile;
        this.loginProvider.getUserDetails().then(userDetail => {
          this.loginDetail = userDetail
          this.societyLogo= this.loginProvider.getSocietyLogo();
          this.setResidentType(this.loginDetail)
        })
         }
  	})
  }



  setResidentType(loginDetail){
    if(loginDetail.role =='resident' ){
        this.residentType= this.translate.instant("OWNER");
        if(loginDetail.tenant==1){
          this.residentType= this.translate.instant('TENANT'); 
        }
    } else if(loginDetail.role =='member'){
      this.residentType= this.translate.instant('FAMILY_MEMBER');
    }  
  }

  toastData(data){
    this.toast.presentToast(data);
  }

}



// WEBPACK FOOTER //
// ./src/pages/resident-id-card/resident-id-card.ts